'use client';

import React, { useEffect } from "react";
import { reportClientError } from "@/utils/clientErrorReporter";
import PropTypes from "prop-types";

// Global error boundary (root)
const GlobalError = ({ error, reset }) => {
  useEffect(() => {
    reportClientError({
      kind: "next.global_error",
      error,
      context: { digest: error?.digest },
      tags: { boundary: "app/global-error.jsx" },
    });
  }, [error]);

  return (
    <html lang="es" className="dark">
      <body>
        <div className="p-6">
          <h2 className="text-lg font-semibold">Ocurrió un error inesperado</h2>
          <p className="mt-2 text-sm opacity-80">
            Puedes intentar recargar. Si vuelve a ocurrir, soporte podrá revisar el registro.
          </p>
          <div className="mt-4 flex gap-2">
            <button className="btn btn-primary" onClick={() => reset()}>
              Reintentar
            </button>
            <button className="btn" onClick={() => window.location.reload()}>
              Recargar
            </button>
          </div>
        </div>
      </body>
    </html>
  );
}

export default GlobalError;


GlobalError.propTypes = {
  error: PropTypes.any,
  reset: PropTypes.any

};